// Auto-generated from divider.spec.js
export default {
  "tagName": "ui-divider",
  "content": [
    "text",
    "icon",
    "image"
  ],
  "contentAttributes": [
    "text",
    "icon",
    "image"
  ],
  "types": [
    "vertical",
    "styled"
  ],
  "variations": [
    "spacing",
    "raised",
    "align",
    "thickness",
    "inset",
    "hidden",
    "clearing"
  ],
  "attributes": [
    "text",
    "icon",
    "image",
    "vertical",
    "styled",
    "spacing",
    "raised",
    "align",
    "thickness",
    "inset",
    "hidden",
    "clearing"
  ],
  "optionAttributes": {
    "solid": "styled",
    "dashed": "styled",
    "dotted": "styled",
    "fade": "styled",
    "soft": "styled",
    "double": "styled",
    "mini": "spacing",
    "tiny": "spacing",
    "small": "spacing",
    "medium": "spacing",
    "large": "spacing",
    "big": "spacing",
    "huge": "spacing",
    "massive": "spacing",
    "start": "align",
    "center": "align",
    "end": "align",
    "thin": "thickness",
    "thick": "thickness",
    "inset-small": "inset",
    "inset-medium": "inset",
    "inset-large": "inset",
    "mini-spacing": "spacing",
    "tiny-spacing": "spacing",
    "small-spacing": "spacing",
    "medium-spacing": "spacing",
    "large-spacing": "spacing",
    "big-spacing": "spacing",
    "huge-spacing": "spacing",
    "massive-spacing": "spacing",
    "thin-thickness": "thickness",
    "medium-thickness": "thickness",
    "thick-thickness": "thickness"
  },
  "propertyTypes": {
    "text": "string",
    "icon": "string",
    "image": "string",
    "vertical": "boolean",
    "styled": "string",
    "spacing": "string",
    "raised": "boolean",
    "align": "string",
    "thickness": "string",
    "inset": "string",
    "hidden": "boolean",
    "clearing": "boolean"
  },
  "allowedValues": {
    "styled": [
      "solid",
      "dashed",
      "dotted",
      "fade",
      "soft",
      "double"
    ],
    "spacing": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ],
    "align": [
      "start",
      "center",
      "end"
    ],
    "thickness": [
      "thin",
      "medium",
      "thick"
    ],
    "inset": [
      "inset-small",
      "inset-medium",
      "inset-large"
    ]
  }
};
